var map = {
	"./cannabis-basics/content.js": [
		"aaa1",
		"chunk-2d213106"
	],
	"./cannabis-effects-interactions/content.js": [
		"f03c",
		"chunk-2d22b990"
	],
	"./cannabis-policy-canada/content.js": [
		"5339",
		"chunk-2d0c7e7a"
	],
	"./cannabis-use-disorder/content.js": [
		"7e83",
		"chunk-2d0e237f"
	],
	"./clinical-use-cannabis-pain/content.js": [
		"761b",
		"chunk-2d0d7266"
	],
	"./clinical-use-therapeutic-applications/content.js": [
		"e28e",
		"chunk-2d224d50"
	],
	"./considerations-authorizing-cannabis/content.js": [
		"047e",
		"chunk-2d0a3d08"
	],
	"./intro-to-ecs/content.js": [
		"1768",
		"chunk-2d0abc5e"
	],
	"./long-term-health-cannabis/content.js": [
		"11d9",
		"chunk-2d0aab6b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ce31";
module.exports = webpackAsyncContext;